import React from 'react';
import { Row } from '../../../../../../ui';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { DetailsFormSection as Section } from '../DetailsFormSection';
import { FirstName } from '../../../../../auth/shared/form-fields/FirstName';
import { LastName } from '../../../../../auth/shared/form-fields/LastName';
import { PhoneNumber } from '../fields/PhoneNumber';
import { Address } from '../fields/Address';
import { City } from '../fields/City';
import { State } from '../fields/State';
import { ZipCode } from '../fields/ZipCode';
import { EmailWithSuggestion } from '../fields/EmailWithSuggestion';
import { EmailSuggestionStore } from '../../../../domain/email-validation/stores/EmailSuggestionStore';

export interface IPersonalDetailsProps {
	emailSuggestionStore?: EmailSuggestionStore;
}
export interface IPersonalDetailsFormData {
	firstName: string;
	lastName: string;
	email: string;
	phoneNumber: string;
	address: string;
	city: string;
	state: string;
	zipCode: string;
}

// This component now is in shared folder because it's used by account feature as well.
// This component has to be replaced with the reusable one.
export const PersonalDetails = ({
	emailSuggestionStore,
}: IPersonalDetailsProps) => {
	const { t } = useTranslation();
	const requiredHint = t('user_sign_up_custom_details_hint');

	return (
		<Section title={t('web_parking_details_personal_details_header')}>
			<Row>
				<FirstName required hint={requiredHint} />
				<LastName required hint={requiredHint} />
			</Row>
			<Row>
				<EmailWithSuggestion
					required
					hint={requiredHint}
					store={emailSuggestionStore}
				/>
				<PhoneNumber required hint={requiredHint} />
			</Row>
			<Row>
				<Address required hint={requiredHint} />
				<City required hint={requiredHint} />
			</Row>
			<Row>
				<State hint={requiredHint} />
				<ZipCode required hint={requiredHint} />
			</Row>
		</Section>
	);
};
